import { render } from "./indexDashbord.vue?vue&type=template&id=67c79caf"
import script from "./indexDashbord.vue?vue&type=script&lang=js"
export * from "./indexDashbord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__